module.exports = __webpack_public_path__ + "img/liguangzhongguo.dc736c14.png";